







































































import Vue from "vue"
import { FieldTypeEnums } from "@/enums/field-type-enums"
import { EntityService } from "@/model/service/entity-service"
import { IDatatable } from "@/components/datatable/Datatable.vue"
import { FieldDescription, FieldTypeEnum } from "@/model/entity/field-descriptor"
import { AxiosResponse } from "axios"

export interface EntityDialogData {
  entity: any
  entityDialog: boolean
  actions: EntityActions
  actionName: string
  FieldTypeEnums: any
  selectedAutocomplete: string
}

export interface EntityActions {
  editAction: boolean
  addAction: boolean
}

export interface IEntityDialog extends Vue, EntityDialogData, EntityActions {
  deleteEntity(entity: any): void

  addEntity(): void

  editEntity(entity: any): void
}

export default Vue.extend({
  data(): EntityDialogData {
    return {
      entity: {},
      entityDialog: false,
      actions: {
        addAction: false,
        editAction: false
      },
      FieldTypeEnums: FieldTypeEnums,
      actionName: "",
      selectedAutocomplete: ""
    }
  },
  props: {
    options: {
      type: Object
    },
    fields: {
      type: Array as () => FieldDescription[],
      default: []
    },
    entityService: {
      type: EntityService
    },
    refreshData: {
      type: Function,
      required: true
    }
  },
  methods: {
    editEntity(entity: any) {
      this.entity = JSON.parse(JSON.stringify(entity))
      this.entityDialog = true
    },
    deleteEntity(entity: any) {
      const vm = this
      this.$confirm(this.$t("entity.address.delete_warning").toString(), this.$t("general.warning").toString(), {
        confirmButtonText: this.$t("general.confirm").toString(),
        cancelButtonText: this.$t("general.cancel").toString(),
        type: "warning"
      })
        .then(() => {
          vm.startLoad()
          vm.entityService.delete(entity.id).then(() => {
            vm.refreshData()
            vm.endLoad()
            vm.actions.editAction = false
          })
        })
        .catch()
    },
    addEntity() {
      this.fields.forEach((fieldDescription: FieldDescription, index: number) => {
        this.$set(this.entity, this.fields[index].fieldName!, "")
      })
      this.entityDialog = true
    },
    save() {
      const vm = this
      vm.startLoad()

      if (this.actions.editAction === true) {
        this.entityService
          .modify(this.entity)
          .then((response: AxiosResponse) => {
            if (!response.data.status) {
              const datatable = vm.$parent.$parent as IDatatable
              datatable.refreshData()
              vm.endLoad()
              vm.actions.editAction = false
              vm.entityDialog = false
            } else {
              vm.$error(vm.$t(response.data.message))
              vm.endLoad()
            }
          })
          .catch((e: any) => {
            vm.endLoad()
            vm.$error(e.response.data.message)
          })
      }

      if (this.actions.addAction === true) {
        this.entityService
          .create(this.entity)
          .then(() => {
            const datatable = vm.$parent.$parent as IDatatable
            datatable.refreshData()
            vm.endLoad()
            vm.actions.addAction = false
            vm.entityDialog = false
          })
          .catch((e: any) => {
            vm.endLoad()
            vm.$error(e.response.data.message)
          })
      }
    },
    closeDialog() {
      this.entity = {}
      this.entityDialog = false
    },
    fuzzySearch(input: string, callback: any) {
      if (input && input.length >= 3) {
        let setApiCall = ""
        this.fields.forEach(element => {
          if (element.fieldName === this.selectedAutocomplete) {
            setApiCall = element.autocompleteFieldApi(this.entity["country"].isoCodeAlpha2)
          }
        })
        this.$http.get(setApiCall + input).then(response => {
          callback(response.data)
        })
      } else {
        callback([])
      }
    },
    setCityAndZipcode(entity: any) {
      this.entity["city"] = entity.name
      this.entity["zipcode"] = entity.postalCode
    },
    setSelectedAutoComplete(value) {
      this.selectedAutocomplete = value
    }
  },

  computed: {
    requiredFields(): FieldDescription[] {
      return this.fields.filter(field => field.isRequired)
    },
    validated(): boolean {
      return (
        this.requiredFields.length === 0 ||
        !exists(
          this.requiredFields.find(
            field =>
              !exists(this.entity[field.fieldName!]) ||
              ((field.fieldType === FieldTypeEnum.TEXT || field.fieldType === FieldTypeEnum.AUTOCOMPLETE) &&
                !notEmpty(this.entity[field.fieldName!]))
          )
        )
      )
    }
  }
})
